export const OAUTH_BROADCAST_CHANNEL = 'blaze-oauth-channel'
export const OAUTH_MESSAGE_TYPE = 'oauth_redirect'
